<template>
  <div
    style="height: 100%;"
    class="pa-4"
  >
    <portal to="app-header">
      <div class="d-flex">
        <router-link
          to="/drawflow/demo1"
          class="mr-2"
        >
          demo1
        </router-link>
        <router-link
          to="/drawflow/demo2"
          class="mr-2"
        >
          demo2
        </router-link>
        <router-link
          to="/drawflow/demo3"
          class="mr-2"
        >
          demo3
        </router-link>
      </div>
    </portal>
    <router-view />
  </div>
</template>

<script>

export default {
}
</script>

<style>

</style>